import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import 'react-dropdown/style.css';
import { useLocation } from 'react-router';
import { nav_options, RIGHT, LEFT } from '@config/config';

function Navbar() {
  const location = useLocation();
  const navOptions = useMemo(() => {
    const currentPath = location.pathname.split('/')[1];
    const clonedNavOptions = nav_options;
    const matchedOptionIndex = nav_options.findIndex((option) => {
      return option.value.split('/')[1] === currentPath;
    });
    clonedNavOptions.forEach((option, index) => {
      option.place = RIGHT;
    });
    clonedNavOptions[matchedOptionIndex].place = LEFT;
    return clonedNavOptions;
  }, [nav_options, location]);

  return (
    <>
      <header className="header">
        <div className="nav">
          <div className="left-section">
            {navOptions
              ?.filter((it) => it.place === LEFT)
              ?.map((it, index) => (
                <div key={`left-item-${index}`} className="kl-header-left-item">
                  <Link to={it.value}>{it.label}</Link>
                </div>
              ))}
          </div>
          <div className="middle-section" />
          <div className="right-section">
            {navOptions
              ?.filter((it) => it.place === RIGHT)
              ?.map((it, index) => (
                <div
                  key={`right-item-${index}`}
                  className="kl-header-right-item"
                >
                  <Link to={it.value}>{it.label}</Link>
                </div>
              ))}
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar;
